(() => {
  const root = document.querySelector('[data-model-product]');
  if (!root) return;


  const select = root.querySelector('[data-model-variant]');
  const updateVariant = (option) => {
    if (!option) return;
    const available = option.dataset.available === 'true';
    const price = option.dataset.price || '';
    root.querySelectorAll('[data-model-price], [data-model-sticky-price]').forEach((node) => { node.textContent = price; });
    root.querySelectorAll('[data-model-submit], [data-model-sticky-submit], [data-model-buy-now]').forEach((button) => {
      button.disabled = !available;
      if (button.matches('[data-model-submit], [data-model-sticky-submit]')) {
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
    const availability = root.querySelector('[data-model-availability]');
    if (availability) {
      availability.classList.toggle('m27-stock--sold-out', !available);
      const label = availability.querySelector('[data-model-availability-label]');
      if (label) label.textContent = available ? 'Available' : 'Currently unavailable';
    }
  };
  select?.addEventListener('change', () => updateVariant(select.selectedOptions[0]));

})();
